module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Danza.a93076a8.png";